module.exports = __webpack_public_path__ + "img/serbia.fb034e20.svg";